import styled from 'styled-components';
import { Col } from 'antd';

export default styled(Col)`
  width: 100%;
  max-width: 380px;
`;
